import styled from 'styled-components';
import { tokens } from '@plataforma/components';
import { grid, colors, fonts } from '_/styles';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
`;

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 1040px;
  min-width: 840px;
`;

export const PageContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 ${grid.large} ${grid.large} ${grid.large};
`;

export const Column = styled.div`
  flex: 1;
  max-width: 456px;

  &:last-child {
    max-width: 400px;
    margin-left: ${grid.large};
  }
`;

export const PageWarning = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 64px;
  font-weight: ${tokens.font.weight.semibold};
  font-size: ${fonts.size.regular};
  max-width: 1040px;
  min-width: 840px;
  border-radius: ${grid.radius};
  color: ${colors.textComplementary};
  background: ${colors.baseGrayLight};
  margin: ${grid.medium} 0;

  ${({ status }) =>
    status === 'underAnalysis' &&
    `
    color:${colors.baseBlue};
    background:${colors.baseBlueLight};
    margin:${grid.medium} 0;
  `}
`;
